
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.247 18H3.753c-.397 0-.74-.136-1.033-.405l5-5.195c.125.093.241.18.345.26.375.286.678.51.911.67.233.16.543.324.93.49.388.168.75.251 1.084.251h.02c.335 0 .696-.083 1.083-.25.387-.167.697-.33.93-.491.234-.16.537-.384.912-.67l.346-.259 4.999 5.194a1.476 1.476 0 01-1.033.405zM2.975 9.067c1.367.96 2.48 1.75 3.345 2.372L2 15.9V8.2c.283.326.608.615.975.867zm16.06 0c.366-.259.688-.548.965-.867v7.7l-4.32-4.459c.92-.664 2.039-1.455 3.354-2.374zM18.392 4c.435 0 .812.16 1.13.477.318.319.477.701.477 1.148 0 .535-.164 1.046-.492 1.533a4.805 4.805 0 01-1.225 1.25 9472.37 9472.37 0 00-4.851 3.409l-.277.201c-.218.16-.399.288-.543.386-.144.098-.318.208-.522.33a3.025 3.025 0 01-.578.275c-.18.06-.348.091-.502.091h-.02c-.154 0-.321-.03-.502-.091a3.032 3.032 0 01-.578-.275 10.215 10.215 0 01-.522-.33 21.187 21.187 0 01-.542-.386l-.277-.201-.15-.109a665.527 665.527 0 00-2.632-1.854 432.305 432.305 0 01-2.06-1.446c-.415-.285-.806-.676-1.175-1.173C2.184 6.737 2 6.275 2 5.848c0-.528.139-.968.417-1.32C2.695 4.176 3.09 4 3.607 4h14.786z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_mail.svg